<template>
  <div>
    <camera-error-layout>
      <template v-slot:header>
        <h3 class="gray-900 mb-4">Habilite o acesso à câmera</h3>
        <p>
          Para tirar a foto do documento é necessário que a câmera esteja habilitada.
        </p>
      </template>

      <template v-slot:content>
        <Asset
          name="o-camera-error-android.svg"
          alt="Barra de pesquisa do android"
          title="Barra de pesquisa do android"
        />

        <div class="tutorial--steps">
          <ol>
            <li>
              Toque no ícone do <b>”cadeado”</b> na barra de navegação do Chrome
            </li>
            <li>
              Em seguida toque em <b>“Configurações do site”</b>
            </li>
            <li>
              Em <b>”Permissões”</b>, escolha <b>”Acessar sua câmera”</b> e
              marque a opção  <b>”Permitir”</b>
            </li>
          </ol>
        </div>
      </template>

      <template v-slot:footer>
        <round-button
          color="primary mt-12"
          content="Recarregar página"
          @click="handleRefreshPage"
        />
      </template>
    </camera-error-layout>
  </div>
</template>

<script>
import Asset from '@/components/common/Asset.vue';
import CameraErrorLayout from '../components/CameraErrorLayout.vue';
import RoundButton from '../../paymentLink/components/RoundButton.vue';

export default {
  name: 'v2-onboarding-error-camera-android',
  components: {
    Asset,
    CameraErrorLayout,
    RoundButton,
  },
  methods: {
    async handleRefreshPage() {
      await this.$router.replace({
        name: 'v2-onboarding-documents',
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .tutorial--steps {
    margin: 16px 0;

    ol {
      list-style-type: numeric;
      list-style-position: inside;

      li {
        margin-bottom: 8px;

        img {
          width: 20px;
          margin: 0;
          margin-left: 6px;
        }
      }
    }
  }
</style>
